import axios from "axios";
import { attachDeviceProof } from "./admin-device";
// 기기 API 는 api-admin 의 /api/v1/admin-devices 다. 앱 공용 인스턴스(baseURL=호스트만)로 '/admin-devices/...' 를
// 부르면 404 라 구관리자 기기 화면이 한 번도 동작하지 않았다(KRE-17, 2026-10-27). 신관리자·왓슨과 같은 전용 인스턴스.
export const deviceApi = axios.create({ timeout: 15000 });
deviceApi.interceptors.request.use(async config => {
  const base = process.env.VUE_APP_HOST;
  if (!base) throw new Error("device_api_not_configured");
  config.baseURL = new URL(base).origin + "/api/v1";
  deviceApi.defaults.baseURL = config.baseURL;
  const token = localStorage.getItem("ad_to_ac_se");
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return attachDeviceProof(config, deviceApi);
});

// 앱 요청에 기기 증명을 붙일 때 서명 대상 경로는 앱 인스턴스 기준, 일회용 nonce 발급은 기기 API 로 보낸다.
export function appDeviceProof(config, app) {
  return attachDeviceProof(config, {
    defaults: app.defaults,
    getUri: app.getUri.bind(app),
    // 첫 요청 전 스위치 힌트 확인(ensureDeviceHints)용 — 상태 조회만 한다(KRE-17).
    get: deviceApi.get.bind(deviceApi),
    post: deviceApi.post.bind(deviceApi),
  });
}
